// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./DropdownButton.Option.css";
import React, { createContext, useContext } from "react";
import {
  exists,
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import { TextPrimitive } from "../_internal_primitives";
import { SelectOptionRoot } from "../_internal_select";

const styles = [
  {
    type: "default",
    layers: {
      DJFgdVooE8: {
        none: {
          text: "List item",
        },
      },
    },
  },
  {
    type: "boolean",
    propName: "selected",
    layers: {
      DJFgdVooE8: {
        none: {
          text: "Selected item",
        },
      },
    },
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
  {
    type: "boolean",
    propName: "selected",
    layers: {},
  },
];

const variantPropTypes = [
  {
    type: "boolean",
    propName: "selected",
  },
];

export const OptionContext = createContext(null);

function Option(_props) {
  const defaults = useContext(OptionContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <SelectOptionRoot
      {...props}
      key="select-option-root"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "select-option-root",
        scope: "YCaC21ACBT",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <TextPrimitive
          id={"text_DJFgdVooE8"}
          className={
            "__visly_reset_7X7HTLRqyD __visly_scope_YCaC21ACBT_DJFgdVooE8"
          }
          key={"DJFgdVooE8"}
          text={
            exists(props.label) ? props.label : getStyle("DJFgdVooE8", "text")
          }
          element={getStyle("DJFgdVooE8", "htmlElement")}
        />
      )}
    </SelectOptionRoot>
  );
}

Option.__variants = [
  {
    name: "selected",
    type: "variant",
  },
];

export default Option;
